import React, { PureComponent, Fragment } from 'react'
import { Skeleton } from '@material-ui/lab';
import DataCard from 'shared/components/DataCard'
import BarChart from 'shared/components/BarChart'

const classes = {
    cardMargin: {
        paddingTop: 15,
        paddingBottom: 15,
    }
}

const SkeletonCard = ({ width, height }) => (
    <div style={classes.cardMargin}>
        <Skeleton style={{ borderRadius: 4 }} variant="rect" width={width} height={height} />
    </div>
)

class SnapshotComponent extends PureComponent {

    formatData = (data) => {
        const keys = Object.keys(data);
        return keys.map(item => ({ 'ordinals': item, 'count': data[item] }))
    }

    render() {
        const { data, isFetching } = this.props;
        // const data = null;
        // const isFetching = true;
        const total = !!data && data.total
        const fundingSource = !!data && this.formatData(data.funding);
        const atRiskSource = !!data && this.formatData(data.risk);
        const stewardingSource = !!data && this.formatData(data.stewarding);

        return (
            <div className="extra-padding">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-5 col-xl-4">
                            {isFetching && (
                                <Fragment>
                                    <SkeletonCard width={'100%'} height={115} />
                                    <SkeletonCard width={'100%'} height={125} />
                                    <SkeletonCard width={'100%'} height={125} />
                                </Fragment>
                            )}
                            {!!total && (
                                <Fragment>
                                    <DataCard
                                        special
                                        value="Snapshot shows the entire dataset. Filters do not affect charts. These calculations may not be exact and depend on numbers provided by local agencies."
                                    />
                                    <DataCard
                                        title="Data Last Updated"
                                        value={(new Date()).toLocaleDateString()}
                                        lg
                                    />
                                    <DataCard
                                        title="Total Subsidized Units"
                                        value={total.toLocaleString()}
                                        lg
                                    />
                                </Fragment>
                            )}

                        </div>
                        <div className="col-7 col-xl-8">
                            {isFetching && (
                                <SkeletonCard width={'100%'} height={426} />
                            )}
                            {!!fundingSource && (
                                <DataCard
                                    title="Number of Units Per Funding Source"
                                    content={(
                                        <BarChart
                                            tiltedLabels
                                            source={fundingSource}
                                            height={340}
                                            color="rgb(31, 120, 180)"
                                            id="funding"
                                            numberOfTicks={6}
                                            paddingBetweenBars={0.26}
                                        />
                                    )}
                                />
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            {isFetching && (
                                <SkeletonCard width={'100%'} height={426} />
                            )}
                            {!!atRiskSource && (
                                <DataCard
                                    title="Number of Units At-Risk of Losing Subisdy"
                                    content={(
                                        <BarChart
                                            source={atRiskSource}
                                            height={340}
                                            color="rgb(51, 175, 168)"
                                            id="atRisk"
                                            numberOfTicks={5}
                                            paddingBetweenBars={0.5}
                                        />
                                    )}
                                />
                            )}
                        </div>
                        <div className="col-6">
                            {isFetching && (
                                <SkeletonCard width={'100%'} height={426} />
                            )}
                            {!!stewardingSource && (
                                <DataCard
                                    title="Number of Units Per Stewarding Agency"
                                    content={(
                                        <BarChart
                                            source={stewardingSource}
                                            height={340}
                                            color="rgb(202, 178, 213)"
                                            id="stewarding"
                                            numberOfTicks={5}
                                            paddingBetweenBars={0.6}
                                        />
                                    )}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SnapshotComponent